
import Modal from "../Layouts/Modal.vue";
export default {
  components: {
    Modal,
  },
  setup() {},
  data() {
    return {
      toggleModal: false,
      args: {
        email: "",
        password: "",
        name: "",
      },
    };
  },
  async mounted() {
    const params = new URLSearchParams(this.$route.query);
    const code = params.get("code");
    if (code) {
      const tokens = await getTokenFromCode(code);
      this.$store.commit("set", {
        type: "accessToken",
        data: tokens.access_token,
      });
      this.$store.commit("set", {
        type: "refreshToken",
        data: tokens.refresh_token,
      });
      this.$router.push("/reader/profile");
    }
  },
  methods: {
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    modal() {
      this.toggleModal = true;
    },
    async signUp() {
      let res = await this.$store.dispatch("post", {
        endpoint: "/auth/register",
        auth: false,
        payload: this.args,
      });
      if (res.status == 201 || 200) {
        this.$router.push("/reader/profile");
        this.reset();
      }
    },
    async signUpWithGoogle() {
      let res = await this.$store.dispatch("get", {
        endpoint: "/auth/google",
        auth: false,
      });
      if (res.status == 200) {
        window.location.href = res.data.authUrl;
      }
    },
  },
};
